<template>
    <el-dialog 
      :title="title"
      class="wechatEdit"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="680px"
      top="3vh"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      v-dialogDrag>
            <el-form ref="form" :rules="rules" :model="form" label-width="120px" v-loading="formLoading">
                <el-form-item label="所属老师" prop="adminId">
                        <el-select
                    v-model="form.adminId"
                    placeholder="请选择所属老师"
                    clearable
                    :filterable="addTypeList.length > 9 ? true : false"
                    :disabled="disableAdminChange"
                    style="width: 250px"
                >
                    <el-option
                        v-for="item in addTypeList"
                        :label="item.value"
                        :value="item.key"
                        :key="item.key"
                    ></el-option>
                </el-select>
                </el-form-item>
        <el-form-item label="微信号" prop="number">
          <el-input style="width: 250px;" placeholder="请输入微信号" v-model="form.number" :maxlength="50"></el-input>
        </el-form-item>
            <el-form-item label="是否企业微信" prop="isEnterprise">
                <el-switch active-text="是" inactive-text="否" v-model="form.isEnterprise"></el-switch>
            </el-form-item>
            <el-form-item label="是否启用" prop="isOpen">
                <el-switch active-text="是" inactive-text="否" v-model="form.isOpen"></el-switch>
            </el-form-item>
            <el-form-item label="自动加好友" prop="isAutoAddFriend">
                <div class="wechat-auto-add-field">
                    <el-switch active-text="是" inactive-text="否" v-model="form.isAutoAddFriend"
                        @change="handleAutoAddFriendChange"></el-switch>
                    <span class="wechat-auto-add-tip red">注：分配接入学员成功后：如果老师未加当前学员为好友时，系统将自动通过被分配学员的微信号，将其加为老师的微信好友；一个老师有且只能将[一个微信号]设置为自动加好友</span>
                </div>
            </el-form-item>
            <el-form-item label="个微助手" prop="personalAssistantType">
                <el-radio-group v-model="form.personalAssistantType" class="personal-assistant-options">
                    <el-radio v-for="item in personalAssistantTypeOptions" :key="item.key" :label="item.key">
                        {{ item.value }}
                    </el-radio>
                </el-radio-group>
                <span class="personal-assistant-tip red">注：如需开启个微助手:慧航业务的老师请选择[开启--小助手平台(慧航)],学历业务的老师请选择[开启--FlowBot机器人平台(学历)]</span>
            </el-form-item>
        </el-form>
        <div class="button">
            <el-button v-if="!isLoading" :disabled="isLoading" type="primary" @click="submitWechat">提交保存</el-button>
            <el-button type="primary" v-else disabled>提交中<i class="el-icon-loading"></i></el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { getAdminList } from '../../network/administrator'
import { GetAdminWeiXin, EditAdminWeixin } from '../../network/teacherWxNumber'
import { getPersonalAssistantTypeList } from '../../network/wechat'
export default {
    name: 'HuihangAdminPcAddWechat',
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        editWxListId: {
            type: Number,
            default: null
        },
        // 是否禁止修改所属老师（用于个人中心入口）
        disableAdminChange: {
            type: Boolean,
            default: false
        },
        hasAutoAddFriend: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                adminId:null,
                number: '',
                isEnterprise: false,
                isOpen: false,
                isAutoAddFriend: false,
                personalAssistantType: null,
                formLoading: false
            },
            rules: {
                adminId:[
                    { required: true, message: '请选择所属老师', trigger: 'blur' },
                ],
                number: [
                    { required: true, message: '请输入微信号', trigger: 'blur' },
                    { max: 50, message: '微信号不能超过50个字符', trigger: ['blur', 'change'] },
                ],
                isEnterprise: [
                    { required: true, message: '请选择是否企业微信', trigger: 'blur' },
                ],
                isOpen: [
                    { required: true, message: '请选择是否启用', trigger: 'blur' },
                ],
                isAutoAddFriend: [
                    { required: false, message: '请选择是否自动加好友', trigger: 'change' },
                ],
                personalAssistantType: [
                    { required: true, message: '请选择个微助手平台', trigger: 'change' },
                ]
            },
            addTypeList:[],
            // 个微助手平台选项统一由后端枚举接口提供，避免前端写死。
            personalAssistantTypeOptions: [],
            title:'添加微信号'
        };
    },

    watch: {
        dialogVisible:{
            handler(newVal) {
                if(!newVal) return
                this.form = {
                    adminId:null,
                    number: '',
                    isEnterprise: false,
                    isOpen: false,
                    isAutoAddFriend: false,
                    personalAssistantType: null,
                    formLoading: false
                }
                if(newVal){
                    this.getPersonalAssistantTypeOptions()
                    this.getAdminData()
                }
                if(this.isEdit){
                    this.title = '编辑微信号'
                    this.getDetail()
                }else{
                    this.title = '添加微信号'
                }
            },
            immediate: true,
            deep: true
        }
    },

    methods: {
        // 获取个微助手平台枚举，供单选按钮组动态渲染。
        async getPersonalAssistantTypeOptions() {
            if (this.personalAssistantTypeOptions.length > 0) {
                if (!this.isEdit && this.form.personalAssistantType == null) {
                    this.form.personalAssistantType = this.personalAssistantTypeOptions[0].key
                }
                return
            }
            try {
                const res = await getPersonalAssistantTypeList()
                this.personalAssistantTypeOptions = res && res.code == 1 ? (res.result || []) : []
                if (!this.isEdit && this.form.personalAssistantType == null) {
                    this.form.personalAssistantType = this.personalAssistantTypeOptions[0]?.key ?? null
                }
            } catch (error) {
                console.error('获取个微助手平台枚举失败:', error)
                this.personalAssistantTypeOptions = []
            }
        },
        handleAutoAddFriendChange(value) {
            if (!value || !this.hasAutoAddFriend) return
            this.form.isAutoAddFriend = false
            this.$message.warning('同一个老师有且只能设置一个自动添加好友的微信号')
        },
        async getDetail(){
            let res = await GetAdminWeiXin(this.editWxListId)
            if(res.code == 1){
                this.form = res.result
            }
        },
        async getAdminData(){
            this.formLoading = true
            let data = {
                ids: [0],
                keyWord: "",
                pageSize: 500,
                adminTypeIds: []
            };
            this.addTypeList = []
            let res = await getAdminList(data)
            if(res.code == 1 && res.result){
                // 去重
                const uniqueIds = new Set();
                res.result.forEach(element => {
                    if(!uniqueIds.has(element.id)){
                        uniqueIds.add(element.id);
                        this.addTypeList.push({
                            key: element.id,
                            value: element.name
                        })
                    }
                });
                this.formLoading = false
            }else{
                this.formLoading = false
            }
            if(!this.isEdit){
                const AdminCache = sessionStorage.getItem('AdminCache') && JSON.parse(sessionStorage.getItem('AdminCache'))
                this.form.adminId = AdminCache.adminId
            }
            
            
        },
        async submitWechat() {
            if (this.isLoading) {
                return false;
            }
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    return false;
                } else {
                   if(this.isEdit){
                    this.$emit('editSubmitWechat', this.form)
                   }else{
                    this.$emit('submitWechat', this.form)
                   }
                }
            });
        },
       
        closeDialog() {
            this.form = {
                adminId:null,
                number: '',
                isEnterprise: false,
                isOpen: false,
                isAutoAddFriend: false,
                personalAssistantType: null,
                formLoading: false
            }
            this.resetFormFields()
            this.$emit('closeDialog')
        },
        resetFormFields() {
            this.form = {
                adminId:null,
                number: '',
                isEnterprise: false,
                isOpen: false,
                isAutoAddFriend: false,
                personalAssistantType: null
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.wechat-auto-add-field {
    display: block;
}

.wechat-auto-add-tip {
    display: block;
    max-width: 360px;
    margin-top: 10px;
    font-size: 12px;
    line-height: 20px;
    white-space: normal;
    word-break: break-word;
}

.personal-assistant-tip {
    display: block;
    width: 380px;
    margin-top: 8px;
    font-size: 12px;
    line-height: 20px;
    color: #f56c6c;
    white-space: normal;
}


.personal-assistant-options {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
</style>
